import { getDirectoryLink } from "../utilities/getDirectoryLink";
import { getGroupDetails } from "./getGroupDetails";
export function openGroupDetails(id, template) {
    const groupData = getGroupDetails(id);
    let groupLeadersHTML = `<h4>Group Leaders</h4><ul>`;
    document.querySelector("body").classList.add("stop-scrolling");
    groupData.groupLeaders.forEach((leader) => {
        const fullName = `${leader["first-name"]} ${leader["last-name"]}`;
        const emailItem = leader.email
            ? `<p class="email">
                <span class="fa-solid fa-envelope" aria-hidden="true"></span>
                <a href="mailto:${leader.email}">${leader.email}</a>
            </p>`
            : "";
        const phoneItem = leader.cell
            ? `
            <p class="phone">
                <span class="fa-solid fa-phone" aria-hidden="true"></span>
                <a href="tel:${leader.cell}">${leader.cell}</a>
            </p>`
            : "";
        groupLeadersHTML += `
            <li>
                <div class="profile-img">
                    <img src="${leader["individual-photo-url"]}" alt="${fullName}" /> 
                </div>
                <p class="name">
                    <span class="fa-solid fa-address-book" aria-hidden="true"></span>
                    <a href="${getDirectoryLink(leader["family-id"], fullName)}" title="Find ${fullName} in Directory">${fullName}</a>  
                </p>
                ${phoneItem}
                ${emailItem}
            </li>`;
    });
    template.id = id;
    template.classList.add("active");
    template.querySelector(".title").innerHTML =
        `<a href="${groupData.groupLink}">${groupData.groupTitle} <span class="fa-solid fa-link"></span></a>`;
    template.querySelector(".group-stats").innerHTML =
        `<p><strong>${groupData.groupTitle}</strong> has <strong>${groupData.memberCount} members</strong>, including children and adults, forming a total of <strong>${groupData.familyCount} families</strong>.</p>`;
    template.querySelector(".group-email").value =
        groupData.groupEmail;
    template.querySelector(".individual-emails").value =
        groupData.memberEmails;
    template.querySelector(".group-leaders").innerHTML = groupData.groupLeaders
        .length
        ? groupLeadersHTML + "</ul>"
        : "";
}
